export const addresses = {
  providerAddress: "0x6B9C4119796C80Ced5a3884027985Fd31830555b",
};
